import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsEmployeeStatus from './SettingsEmployeeStatus';

function EmployeeStatusPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Employee Status"
        subtitle="Configure employment statuses"
        backTo="/settings/hr"
        backLabel="HR Management"
        sticky
      />
      <div className="p-6">
        <SettingsEmployeeStatus />
      </div>
    </div>
  );
}

export default EmployeeStatusPage;
